import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import {
    CircleUserIcon,
    BarsIcon,
    ChevronDownIcon,
    Dashboard,
    Logout,
    SettingIcon
} from '../../icons/FontAwesomeIcon';
import { H4, Body2 } from '../../themes/typography';
import Shmooz from '../../assets/images/Shmooz-Logo.png';
import IconButton from '@mui/joy/IconButton';
import Menu from '@mui/joy/Menu';
import MenuItem from '@mui/joy/MenuItem';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import ListDivider from '@mui/joy/ListDivider';
import Grow from '@mui/material/Grow';
import {
    openAuthDialog,
    setActiveAuthModule,
    setActiveAuthModuleForm
} from '../../app/store/slices/authDialog';
import { authModules, authModulesForms } from '../../app/store/slices/authDialog';
import { signOutUser } from '../../app/store/slices/auth/authSlice';
import '../../styles/components/Navbar.css';

export default function Navbar() {
    const navigate = useNavigate()
    const { isLoggedIn, user } = useSelector((state) => state.auth);

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const dispatch = useDispatch();

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    function handleLogout() {
        dispatch(signOutUser());
        handleMenuClose();
    }

    // Handle "Create Event" click
    const handleCreateEventClick = (e) => {
        e.preventDefault();
        if (isLoggedIn && user?.id) {
            navigate('/event/new/event-details');
        } else {
            dispatch(openAuthDialog());
            dispatch(setActiveAuthModule(authModules.LOGIN));
            dispatch(setActiveAuthModuleForm(authModulesForms.LOGIN_FORM));
        }
    };

    return (
        <>
            <nav className="navbar">
                <div className="navbar-logo">
                    <Link to="/">
                        <img src={Shmooz} alt="Shmooz Logo" className="logo-image" />
                    </Link>
                </div>
                <div className="navbar-menu">
                    <ul>
                        <Link to="/events">
                            <H4>Events</H4>
                        </Link>

                        <Link to="/event/new/event-details" onClick={handleCreateEventClick}>
                            <H4>Create Event</H4>
                        </Link>
                        
                        {isLoggedIn && (
                            <Link>
                                <H4>{user?.name}</H4>
                            </Link>
                        )}
                    </ul>
                    <div className="user-account-section">
                        <CircleUserIcon style={{ color: '#26C1E8', fontSize: '2rem' }} />
                        <IconButton
                            // variant="outlined"
                            // color="neutral"
                            color="primary"
                            onClick={handleMenuClick}
                            aria-controls={open ? 'user-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                            sx={{
                                // padding: '0px',
                                transition: 'all 0.2s ease-in-out',
                                fontSize: '1.2rem',
                                '&:hover': {
                                    backgroundColor: '#26C1E8',
                                    color: '#11203A'
                                }
                            }}
                        >
                            <ChevronDownIcon />
                        </IconButton>
                        <Menu
                            TransitionComponent={Grow}
                            transitionDuration={1000}
                            sx={{
                                gap: '5px'
                            }}
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleMenuClose}
                            placement="bottom-end"
                            id="user-menu"
                        >
                            {/* <MenuItem onClick={handleMenuClose}>
                                <ListItemDecorator>
                                    <Dashboard />
                                </ListItemDecorator>
                                <Link to={'/event/dashboard'}>
                                    <Body2 color="var(--primary-color)">Dashboard</Body2>
                                </Link>
                            </MenuItem> */}

                            {isLoggedIn && (
                                <MenuItem onClick={handleMenuClose}>
                                    <ListItemDecorator>
                                        <Dashboard />
                                    </ListItemDecorator>
                                    <Link to={'/user/dashboard'}>
                                        <Body2 color="var(--primary-color)">Dashboard</Body2>
                                    </Link>
                                </MenuItem>
                            )}

                            {!isLoggedIn && (
                                <MenuItem
                                    onClick={() => {
                                        dispatch(openAuthDialog());
                                        dispatch(setActiveAuthModule(authModules.LOGIN));
                                        dispatch(
                                            setActiveAuthModuleForm(authModulesForms.LOGIN_FORM)
                                        );
                                        handleMenuClose();
                                    }}
                                >
                                    <ListItemDecorator>
                                        <SettingIcon />
                                    </ListItemDecorator>{' '}
                                    Login
                                </MenuItem>
                            )}

                            {/* <MenuItem onClick={() => {
                                dispatch(openAuthDialog());
                                dispatch(setActiveAuthModule(authModules.REGISTER));
                                dispatch(setActiveAuthModuleForm(authModulesForms.VERIFY_EMAIL_FORM));
                                handleMenuClose();
                            }}>
                                <ListItemDecorator>
                                    <SettingIcon />
                                </ListItemDecorator>{' '}
                                Sign Up
                            </MenuItem> */}
                            <ListDivider />

                            {isLoggedIn && (
                                <MenuItem variant="soft" color="danger" onClick={handleLogout}>
                                    <ListItemDecorator sx={{ color: 'inherit' }}>
                                        <Logout />
                                    </ListItemDecorator>{' '}
                                    Logout
                                </MenuItem>
                            )}

                        </Menu>
                    </div>
                </div>
                <div className="navbar-toggle">
                    <BarsIcon style={{ color: '#FFFFFF', fontSize: '1.2rem' }} />
                </div>
            </nav>
        </>
    );
}
